import { APP_ROUTES } from "../constants";

/**
 * Phone capture happens right after the CIP gate (whether CIP ran or was
 * skipped) and is driven by the optional `hasPhoneNumber` flag from /claim.
 * Only an explicit `true` skips it — backends that do not report the flag
 * yet leave it `undefined`, and we would rather ask than silently skip:
 *
 *  hasPhoneNumber │ next route
 *  ───────────────┼────────────────────────────
 *  true           │ SendingMoney
 *  false          │ PhoneNumber → SendingMoney
 *  undefined      │ PhoneNumber → SendingMoney
 *
 * `phonePromptSkipped` ("Ahora no") skips the screen for the current
 * operation only; it is reset once the operation is created.
 */
export const getRouteAfterCipGate = (
  hasPhoneNumber?: boolean,
  phonePromptSkipped = false
): string =>
  hasPhoneNumber === true || phonePromptSkipped
    ? APP_ROUTES.SENDING_MONEY_PAGE
    : APP_ROUTES.PHONE_NUMBER_PAGE;
